// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/jquery-confirm/dist/jquery-confirm.min.css
// module id = 794
// module chunks = 1